// extracted by mini-css-extract-plugin
export default {"icon":"Empty_icon__GUmN0","text":"Empty_text__Gjso-"};